import useUser, { isUserPendingRegistration, useLoadedUser } from './api/useUser';

export type AppType = 'consumer' | 'professional';

/**
 * Handles the scenario where the user is not yet loaded.  Will fallback to consumer app type.
 */
export const useMaybeLoadingAppType = (): AppType => {
    const { user } = useUser({});
    const userType = user === 'loading' ? 'consumer' : user.type;
    return userType === 'professional' ? 'professional' : 'consumer';
};

/**
 * Handles the scenario where the user is not yet loaded or user type not explicitly specified.
 * Will fallback to undefined if the user is loading or pending registration.
 */
export const useExplicitAppType = (): AppType | undefined => {
    const { user } = useUser({});
    if (user === 'loading') {
        return undefined;
    } else if (user.type) {
        return user.type === 'professional' ? 'professional' : 'consumer';
    } else if (isUserPendingRegistration(user)) {
        // pending registration
        return undefined;
    } else {
        return user.type === 'professional' ? 'professional' : 'consumer';
    }
};

export const useAppType = (): AppType => {
    const { user } = useLoadedUser({});
    return user.type === 'professional' ? 'professional' : 'consumer';
};

export const useIsProApp = () => {
    return useAppType() === 'professional';
};

export const useIsConsumerApp = () => {
    return useAppType() === 'consumer';
};
